import React from "react";

const UpsellBlock = (props) => {

    if (!Object.values(props.content).some(value => Boolean(value))) return null;

    return (
        <div className={`upsell-block upsell-block__${props.type}`}>
            <div className="upsell-block__content">
                {props.content.title?.innerHTML &&
                    <h3 className="upsell-block__header" dangerouslySetInnerHTML={{__html: props.content.title.innerHTML}}></h3>
                }
                {props.content.introduction?.innerHTML &&
                    <div className="upsell-block__introduction" dangerouslySetInnerHTML={{__html: props.content.introduction.innerHTML}}></div>
                }
                {props.content.button?.innerHTML &&
                    <div className='upsell-block__button' dangerouslySetInnerHTML={{__html: props.content.button.innerHTML}}></div>
                }
            </div>
            {props.content.image?.innerHTML &&
                <div className="upsell-block__image" dangerouslySetInnerHTML={{__html: props.content.image.innerHTML}}></div>
            }
        </div>
    );
};

export default UpsellBlock;